import { ApolloProvider } from '@apollo/client/react';
import { dark, light } from '@servicetitan/anvil-themes';
import {
  ThemeProvider,
  usePrefersColorScheme,
} from '@servicetitan/design-system';
import { AnvilProvider } from '@servicetitan/anvil2';
import modules from '../modules';
import DiagnosticsProvider from '../modules/DiagnosticsModule/DiagnosticsProvider';
import appManager from './appManager';
import Router from './Router';
import { getClient } from '@api/client';
import ToastsGroup from '@modules/ToastModule/components/ToastsGroup';
import SoftPhoneLoader from '@modules/SoftPhoneModule/components/SoftPhoneLoader';
import BugReportProvider from '@components/BugReportProvider/BugReportProvider';
import styles from './App.module.css';
import { ModalsGroup } from '@modules/ModalsModule/ModalsGroup';
import { HelpCenterMfeLoader } from '@modules/HelpCenterModule/components/HelpCenterMfeLoader';
import FeatureFlagModule from '@modules/FeatureFlagModule';
import {
  GlobalErrorBoundary,
  ModuleErrorBoundary,
} from '@components/ErrorBoundary';

appManager.start(modules);

const client = getClient();
window.client = client;

// expose globally so it can be accessed from cypress tests
Object.defineProperty(window, 'FeatureFlagModule', {
  value: FeatureFlagModule,
  writable: false,
  configurable: true, // just in case
});

function App() {
  const { theme } = usePrefersColorScheme(light, dark);

  return (
    <GlobalErrorBoundary>
      <AnvilProvider className={styles.AppContainer}>
        <ApolloProvider client={client}>
          <BugReportProvider>
            <ThemeProvider theme={theme}>
              <DiagnosticsProvider>
                <Router />
                <ModuleErrorBoundary moduleName='ToastModule' size='compact'>
                  <ToastsGroup />
                </ModuleErrorBoundary>
                <ModuleErrorBoundary moduleName='ModalsGroup' size='compact'>
                  <ModalsGroup />
                </ModuleErrorBoundary>
                <ModuleErrorBoundary
                  moduleName='SoftPhoneModule'
                  size='compact'
                >
                  <SoftPhoneLoader />
                </ModuleErrorBoundary>
                <ModuleErrorBoundary moduleName='HelpCenter' size='full'>
                  <HelpCenterMfeLoader />
                </ModuleErrorBoundary>
              </DiagnosticsProvider>
            </ThemeProvider>
          </BugReportProvider>
        </ApolloProvider>
      </AnvilProvider>
    </GlobalErrorBoundary>
  );
}

export default App;
